import { Box, Button, Modal, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ActivateUserModal: FC<Props> = ({ isOpen, setIsOpen }) => {
  const { isActivating, userActivate } = useSingleUserControl();

  const handleClose = () => {
    if (!isActivating) {
      setIsOpen(false);
    }
  };

  // Cerramos el popup cuando se ejecute la función
  useEffect(() => {
    if (!isActivating && isOpen) {
      handleClose();
    }
  }, [isActivating]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component={"div"}
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Typography component={"h3"} sx={{ fontSize: "20px", fontWeight: 600 }}>
          ¿Quieres re-activar este usuario?
        </Typography>

        {/* Lista de acciones */}
        <Box>
          <Typography sx={{ fontWeight: 600, mb: 1 }}>
            Esta acción se encargará de:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            <li>Crear / activar al usuario en RDS</li>
            <li>Crear / activar al usuario en Cognito</li>
            <li>Crear / activar al usuario en DynamoDB</li>
          </ul>
        </Box>

        {/* Lista de NO acciones */}
        <Box>
          <Typography sx={{ fontWeight: 600, mb: 1 }}>
            Esto <span style={{ color: "red" }}>NO</span> se encargará de:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            <li>Agregar el usuario a una organización</li>
            <li>Agregar el usuario a una suscripción</li>
            <li>Agregar el usuario a un rol</li>
          </ul>
        </Box>

        <Box
          sx={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            gap: 3,
            mt: 3,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setIsOpen(false)}
            disabled={isActivating}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isActivating}
            onClick={userActivate}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ActivateUserModal;
